import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';
import { useAuth } from '../lib/auth';

// Global trigger for the LOGIN modal on the public site.
// A link whose href ends with #login (or a window 'aux:open-login' event) opens
// the login modal — so the operator can wire ANY button (hero, section, footer)
// to it from the Page Builder by setting its URL to #login.
// AUTH-AWARE: when the visitor already has a session, #login does NOT show the
// login modal — it takes them straight to /my-account (a logged-in user has no
// use for a login form). Mirrors the WaitingListModal trigger pattern.
// The navbar "Login" button keeps its own LoginModal; this is additive.
export default function LoginModalTrigger() {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const navigate = useNavigate();
  const { user } = useAuth();

  // Read fresh auth state inside the stable listener without re-registering it.
  const loggedInRef = useRef(!!user);
  loggedInRef.current = !!user;

  const trigger = useCallback(() => {
    if (loggedInRef.current) { navigate('/my-account'); return; }
    setOpen(true);
  }, [navigate]);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href$="#login"]');
      if (a) { e.preventDefault(); trigger(); }
    };
    const onEvt = () => trigger();
    document.addEventListener('click', onClick);
    window.addEventListener('aux:open-login', onEvt);
    return () => { document.removeEventListener('click', onClick); window.removeEventListener('aux:open-login', onEvt); };
  }, [trigger]);

  return <LoginModal open={open} onClose={close} />;
}
